import { CollapsibleSection, CustomLayerToggle } from '@uofu-uss-gis/ui-react';
import { LocalActivityOutlined } from '@mui/icons-material';
import { EVENT_PARKING_LAYER_CONFIG } from '../../config/eventParkingConfig';
import { useEventVisibilityStore } from '../../store/eventVisibilityStore';

function UParkEventParkingSection() {
  const enabledEvents = useEventVisibilityStore((state) => state.enabledEvents);
  const enabledLayers = useEventVisibilityStore((state) => state.enabledLayers);
  const eventLayers = EVENT_PARKING_LAYER_CONFIG;

  return (
    <CollapsibleSection title="Event Parking" icon={LocalActivityOutlined}>
      {eventLayers.map((eventLayer) => {
        if (!enabledLayers[eventLayer.layerId]) return null;
        // Get all other event layer IDs for mutually exclusive behavior
        const otherEventIds = eventLayers
          .filter((e) => e.layerId !== eventLayer.layerId)
          .map((e) => e.layerId);

        const isEnabled = !!enabledEvents[eventLayer.layerId];

        return (
          <div key={eventLayer.layerId} className={`py-2 ${isEnabled ? '' : 'opacity-80'}`}>
            <CustomLayerToggle
              layerId={eventLayer.layerId}
              label={eventLayer.title}
              icon="/app/resources/images/icons/parking/rndE.png"
              mutuallyExclusiveWith={otherEventIds}
            />
            {eventLayer.downloadableMapUrl && (
              <div className="pl-10 pr-2 pt-1">
                <a
                  href={eventLayer.downloadableMapUrl}
                  target="_blank"
                  className="text-md text-[#FF1F1F] underline"
                >
                  Downloadable Map
                </a>
              </div>
            )}
          </div>
        );
      })}
    </CollapsibleSection>
  );
}

export default UParkEventParkingSection;
